import React from 'react';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { FormattedMessage } from 'react-intl';

import ErrorDisplay, { ExtendedErrorDisplayProps } from 'ui/ErrorDisplay';

import messages from './messages';

const NoResults = (props: ExtendedErrorDisplayProps) => {
  return (
    <ErrorDisplay Icon={SearchOffIcon} {...props}>
      <FormattedMessage {...messages.message} />
    </ErrorDisplay>
  );
};

export default NoResults;
